<template>
  <div>
    <h4 style="text-align: center; padding-top: 0 !important">Atenção</h4>
    <h6 v-if="totalDiligencias > 0 || totalCitacoes > 0 || totalAvisos > 0 || totalSolicitacoesAssinatura > 0"
      style="text-align: left">
      Você possui comunicações:
    </h6>
    <div v-if="spanAvisos">
      <span style="float: left">{{ spanAvisos }}</span><br />
    </div>
    <div v-if="spanSolicitacoesAssinatura">
      <span style="float: left">{{ spanSolicitacoesAssinatura }}</span><br />
    </div>
    <div v-if="spanDiligencias">
      <span style="float: left">{{ spanDiligencias }}</span><br />
    </div>
    <div v-if="spanCitacoes">
      <span style="float: left">{{ spanCitacoes }}</span><br />
    </div>
    <div v-if="spanIntimacoes">
      <span style="float: left">{{ spanIntimacoes }}</span><br />
    </div>
    <div v-if="spanAvisosComResposta">
      <span style="float: left">{{ spanAvisosComResposta }}</span><br />
    </div>
    <div v-if="spanOficios">
      <span style="float: left">{{ spanOficios }}</span><br />
    </div>
    <div v-if="spanDeterminacoes">
      <span style="float: left">{{ spanDeterminacoes }}</span><br />
    </div>
    <div v-if="spanTAGs">
      <span style="float: left">{{ spanTAGs }}</span><br />
    </div>
    <div v-if="spanCautelares">
      <span style="float: left">{{ spanCautelares }}</span>
    </div>
    <span class="mt-3" style="float: left">Consulte estas comunicações no menu
      <strong>Processo Eletrônico</strong> >
      <strong>Comunicações processuais</strong>, solicitações de assinatura no mesmo menu, e os avisos no
      <strong>Mural de Avisos</strong>.</span>
  </div>
</template>

<script>
export default {
  props: [
    "diligenciasNaoLidas",
    "diligenciasNaoRespondidas",
    "citacoesNaoLidas",
    "citacoesNaoRespondidas",
    "intimacoesNaoLidas",
    "intimacoesNaoRespondidas",
    "avisosComRespostaNaoLidas",
    "avisosComRespostaNaoRespondidas",
    "oficiosNaoLidas",
    "oficiosNaoRespondidas",
    "determinacoesNaoLidas",
    "determinacoesNaoRespondidas",
    "tagsNaoLidas",
    "tagsNaoRespondidas",
    "cautelaresNaoLidas",
    "cautelaresNaoRespondidas",
    "avisosNaoLidos",
    "assinaturasPendentes",
  ],
  data() {
    return {
      totalAvisos: this.avisosNaoLidos,
      totalDiligencias:
        this.diligenciasNaoLidas + this.diligenciasNaoRespondidas,
      totalCitacoes: this.citacoesNaoLidas + this.citacoesNaoRespondidas,
      totalIntimacoes: this.intimacoesNaoLidas + this.intimacoesNaoRespondidas,
      totalAvisosComResposta:
        this.avisosComRespostaNaoLidas + this.avisosComRespostaNaoRespondidas,
      totalOficios: this.oficiosNaoLidas + this.oficiosNaoRespondidas,
      totalDeterminacoes:
        this.determinacoesNaoLidas + this.determinacoesNaoRespondidas,
      totalTags: this.tagsNaoLidas + this.tagsNaoRespondidas,
      totalCautelares: this.cautelaresNaoLidas + this.cautelaresNaoRespondidas,
      totalSolicitacoesAssinatura: this.assinaturasPendentes,
    };
  },
  computed: {
    spanAvisos() {
      if (this.totalAvisos <= 0) return null;
      else {
        let spanAvisos = "";
        if (this.avisosNaoLidos > 0) {
          if (this.avisosNaoLidos > 1)
            spanAvisos += `${this.avisosNaoLidos} avisos não lidos `;
          else spanAvisos += `${this.avisosNaoLidos} aviso não lido`;
        }
        return spanAvisos;
      }
    },
    spanDiligencias() {
      return this.spanGenerico(
        this.totalDiligencias,
        this.diligenciasNaoRespondidas,
        this.diligenciasNaoLidas,
        "diligências",
        "diligência",
        true
      );
    },
    spanCitacoes() {
      return this.spanGenerico(
        this.totalCitacoes,
        this.citacoesNaoRespondidas,
        this.citacoesNaoLidas,
        "citações",
        "citação",
        true
      );
    },
    spanIntimacoes() {
      return this.spanGenerico(
        this.totalIntimacoes,
        this.intimacoesNaoRespondidas,
        this.intimacoesNaoLidas,
        "intimações",
        "intimação",
        true
      );
    },
    spanAvisosComResposta() {
      return this.spanGenerico(
        this.totalAvisosComResposta,
        this.avisosComRespostaNaoRespondidas,
        this.avisosComRespostaNaoLidas,
        "avisos com resposta",
        "aviso com resposta",
        false
      );
    },
    spanOficios() {
      return this.spanGenerico(
        this.totalOficios,
        this.oficiosNaoRespondidas,
        this.oficiosNaoLidas,
        "ofícios",
        "ofício",
        false
      );
    },
    spanDeterminacoes() {
      return this.spanGenerico(
        this.totalDeterminacoes,
        this.determinacoesNaoRespondidas,
        this.determinacoesNaoLidas,
        "determinações",
        "determinação",
        true
      );
    },
    spanTAGs() {
      return this.spanGenerico(
        this.totalTags,
        this.tagsNaoRespondidas,
        this.tagsNaoLidas,
        "termos de ajustamento de gestão",
        "termo de ajustamento de gestão",
        false
      );
    },
    spanCautelares() {
      return this.spanGenerico(
        this.totalCautelares,
        this.cautelaresNaoRespondidas,
        this.cautelaresNaoLidas,
        "cautelares",
        "cautelar",
        true
      );
    },
    spanSolicitacoesAssinatura() {
      if (this.totalSolicitacoesAssinatura <= 0) return null;
      else {
        let spanSA = "";
        if (this.totalSolicitacoesAssinatura > 0) {
          if (this.totalSolicitacoesAssinatura > 1)
            spanSA += `${this.totalSolicitacoesAssinatura} solicitações de assinatura `;
          else spanSA += `${this.totalSolicitacoesAssinatura} solicitação de assinatura`;
        }
        return spanSA;
      }
    },
  },
  methods: {
    /**
     * Retorna strings do tipo "5 intimações não respondidas 1 intimação não lida".
     * @since 20220412
     */
    spanGenerico(qtd, qtdNR, qtdNL, plural, singular, feminino) {
      if (qtd <= 0) return null;
      else {
        let retorno = "";
        if (qtdNR > 0) {
          if (qtdNR > 1)
            retorno += `${qtdNR} ${plural} não ${feminino ? "respondidas" : "respondidos"
              }`;
          else
            retorno += `${qtdNR} ${singular} não ${feminino ? "respondida" : "respondido"
              }`;
        }
        if (qtdNL > 0) {
          if (retorno.length > 0) retorno += ", ";
          if (qtdNL > 1)
            retorno += `${qtdNL} ${plural} não ${feminino ? "lidas" : "lidos"
              }`;
          else
            retorno += `${qtdNL} ${singular} não ${feminino ? "lida" : "lido"}`;
        }
        return retorno;
      }
    },
  },
};
</script>